(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    root['kotlinx-serialization-kotlinx-serialization-json'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-json'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
  var protoOf = kotlin_kotlin.$_$.fa;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var StringFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p2;
  var classMeta = kotlin_kotlin.$_$.z8;
  var VOID = kotlin_kotlin.$_$.g;
  var toString = kotlin_kotlin.$_$.ka;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.m1;
  var charSequenceLength = kotlin_kotlin.$_$.x8;
  var charSequenceGet = kotlin_kotlin.$_$.w8;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.f2;
  var equals = kotlin_kotlin.$_$.c9;
  var Enum = kotlin_kotlin.$_$.zc;
  var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.d1;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var hashCode = kotlin_kotlin.$_$.j9;
  var joinToString = kotlin_kotlin.$_$.n6;
  var Map = kotlin_kotlin.$_$.c5;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var getBooleanHashCode = kotlin_kotlin.$_$.f9;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var List = kotlin_kotlin.$_$.a5;
  var NumberFormatException_init_$Create$ = kotlin_kotlin.$_$.x1;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.h4;
  var numberRangeToNumber = kotlin_kotlin.$_$.z9;
  var ClosedRange = kotlin_kotlin.$_$.ma;
  var isInterface = kotlin_kotlin.$_$.t9;
  var contains = kotlin_kotlin.$_$.ra;
  var toDouble = kotlin_kotlin.$_$.gc;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.j4;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
  var toLongOrNull = kotlin_kotlin.$_$.jc;
  var toULongOrNull = kotlin_kotlin.$_$.oc;
  var ULong = kotlin_kotlin.$_$.sd;
  var Companion_getInstance = kotlin_kotlin.$_$.r4;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.k3;
  var toDoubleOrNull = kotlin_kotlin.$_$.fc;
  var toBooleanStrictOrNull = kotlin_kotlin.$_$.ec;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var lazy_0 = kotlin_kotlin.$_$.he;
  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var KProperty1 = kotlin_kotlin.$_$.wa;
  var getPropertyCallableRef = kotlin_kotlin.$_$.h9;
  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var toLong = kotlin_kotlin.$_$.ia;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.a3;
  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.c3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.j3;
  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.l3;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.r2;
  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.t2;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.s3;
  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.u3;
  var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var captureStack = kotlin_kotlin.$_$.t8;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var charSequenceSubSequence = kotlin_kotlin.$_$.y8;
  var coerceAtLeast = kotlin_kotlin.$_$.na;
  var coerceAtMost = kotlin_kotlin.$_$.pa;
  var Companion_instance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var singleOrNull = kotlin_kotlin.$_$.i7;
  var emptyMap = kotlin_kotlin.$_$.c6;
  var getValue = kotlin_kotlin.$_$.j6;
  var fillArrayVal = kotlin_kotlin.$_$.e9;
  var copyOf = kotlin_kotlin.$_$.x5;
  var copyOf_0 = kotlin_kotlin.$_$.y5;
  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var DeepRecursiveFunction = kotlin_kotlin.$_$.xc;
  var invoke = kotlin_kotlin.$_$.ce;
  var CoroutineImpl = kotlin_kotlin.$_$.n8;
  var DeepRecursiveScope = kotlin_kotlin.$_$.yc;
  var Unit = kotlin_kotlin.$_$.vd;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z7;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var getKClass = kotlin_kotlin.$_$.f;
  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q2;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
  var substringBefore = kotlin_kotlin.$_$.bc;
  var removeSuffix = kotlin_kotlin.$_$.sb;
  var substringAfter = kotlin_kotlin.$_$.zb;
  var contains_0 = kotlin_kotlin.$_$.za;
  var plus = kotlin_kotlin.$_$.je;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
  var IllegalArgumentException = kotlin_kotlin.$_$.cd;
  var isFinite = kotlin_kotlin.$_$.ee;
  var isFinite_0 = kotlin_kotlin.$_$.de;
  var toUInt = kotlin_kotlin.$_$.nc;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.b3;
  var toULong = kotlin_kotlin.$_$.pc;
  var toUByte = kotlin_kotlin.$_$.mc;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.s2;
  var toUShort = kotlin_kotlin.$_$.qc;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.t3;
  var objectCreate = kotlin_kotlin.$_$.da;
  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var OBJECT_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.ie;
  var findPolymorphicSerializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r2;
  var SerializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var toString_0 = kotlin_kotlin.$_$.m2;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.q4;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.p4;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.s4;
  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var setOf = kotlin_kotlin.$_$.h7;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.l2;
  var numberToChar = kotlin_kotlin.$_$.aa;
  var equals_0 = kotlin_kotlin.$_$.eb;
  var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
  var ByteCompanionObject_instance = kotlin_kotlin.$_$.e4;
  var toByte = kotlin_kotlin.$_$.ha;
  var ShortCompanionObject_instance = kotlin_kotlin.$_$.i4;
  var toShort = kotlin_kotlin.$_$.ja;
  var single = kotlin_kotlin.$_$.ub;
  var Char = kotlin_kotlin.$_$.vc;
  var emptySet = kotlin_kotlin.$_$.d6;
  var plus_0 = kotlin_kotlin.$_$.z6;
  var toInt = kotlin_kotlin.$_$.ic;
  var toList = kotlin_kotlin.$_$.o7;
  var enumEntries = kotlin_kotlin.$_$.p8;
  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
  var last = kotlin_kotlin.$_$.t6;
  var removeLast = kotlin_kotlin.$_$.e7;
  var lastIndexOf = kotlin_kotlin.$_$.qb;
  var Long = kotlin_kotlin.$_$.ed;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.h2;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.n4;
  var numberToLong = kotlin_kotlin.$_$.ca;
  var charArray = kotlin_kotlin.$_$.v8;
  var indexOf = kotlin_kotlin.$_$.ib;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.c1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.n;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Json, 'Json', classMeta, VOID, [StringFormat]);
  setMetadataFor(Default, 'Default', objectMeta, Json);
  setMetadataFor(JsonBuilder, 'JsonBuilder', classMeta);
  setMetadataFor(JsonImpl, 'JsonImpl', classMeta, Json);
  setMetadataFor(JsonClassDiscriminator, 'JsonClassDiscriminator', classMeta);
  setMetadataFor(JsonNames, 'JsonNames', classMeta);
  setMetadataFor(JsonConfiguration, 'JsonConfiguration', classMeta);
  setMetadataFor(ClassDiscriminatorMode, 'ClassDiscriminatorMode', classMeta, Enum);
  setMetadataFor(JsonDecoder, 'JsonDecoder', interfaceMeta, VOID, [Decoder, CompositeDecoder]);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(JsonElement, 'JsonElement', classMeta, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(JsonObject, 'JsonObject', classMeta, JsonElement, [JsonElement, Map], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  setMetadataFor(JsonPrimitive, 'JsonPrimitive', classMeta, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  setMetadataFor(JsonNull, 'JsonNull', objectMeta, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNull_getInstance});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(JsonLiteral, 'JsonLiteral', classMeta, JsonPrimitive);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(JsonArray, 'JsonArray', classMeta, JsonElement, [JsonElement, List], VOID, VOID, {0: JsonArraySerializer_getInstance});
  setMetadataFor(JsonElementSerializer, 'JsonElementSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonObjectDescriptor, 'JsonObjectDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonObjectSerializer, 'JsonObjectSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonArrayDescriptor, 'JsonArrayDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonArraySerializer, 'JsonArraySerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonNullSerializer, 'JsonNullSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonLiteralSerializer, 'JsonLiteralSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(defer$1, VOID, classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonEncoder, 'JsonEncoder', interfaceMeta, VOID, [Encoder, CompositeEncoder]);
  setMetadataFor(Composer, 'Composer', classMeta);
  setMetadataFor(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', classMeta, Composer);
  setMetadataFor(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', classMeta, Composer);
  setMetadataFor(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', classMeta, Composer);
  setMetadataFor(JsonElementMarker, 'JsonElementMarker', classMeta);
  setMetadataFor(JsonException, 'JsonException', classMeta, SerializationException);
  setMetadataFor(JsonEncodingException, 'JsonEncodingException', classMeta, JsonException);
  setMetadataFor(JsonDecodingException, 'JsonDecodingException', classMeta, JsonException);
  setMetadataFor(Tombstone, 'Tombstone', objectMeta);
  setMetadataFor(JsonPath, 'JsonPath', classMeta, VOID, VOID, JsonPath);
  setMetadataFor(JsonTreeReader$readDeepRecursive$slambda, 'JsonTreeReader$readDeepRecursive$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [2]);
  setMetadataFor($readObjectCOROUTINE$0, '$readObjectCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor(JsonTreeReader, 'JsonTreeReader', classMeta, VOID, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(PolymorphismValidator, 'PolymorphismValidator', classMeta, VOID, [SerializersModuleCollector]);
  setMetadataFor(Key, 'Key', classMeta, VOID, VOID, Key);
  setMetadataFor(DescriptorSchemaCache, 'DescriptorSchemaCache', classMeta, VOID, VOID, DescriptorSchemaCache);
  setMetadataFor(DiscriminatorHolder, 'DiscriminatorHolder', classMeta);
  setMetadataFor(StreamingJsonDecoder, 'StreamingJsonDecoder', classMeta, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
  setMetadataFor(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', classMeta, AbstractDecoder);
  setMetadataFor(StreamingJsonEncoder, 'StreamingJsonEncoder', classMeta, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
  setMetadataFor(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', classMeta, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  setMetadataFor(JsonTreeDecoder, 'JsonTreeDecoder', classMeta, AbstractJsonTreeDecoder);
  setMetadataFor(JsonTreeListDecoder, 'JsonTreeListDecoder', classMeta, AbstractJsonTreeDecoder);
  setMetadataFor(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', classMeta, AbstractJsonTreeDecoder);
  setMetadataFor(JsonTreeMapDecoder, 'JsonTreeMapDecoder', classMeta, JsonTreeDecoder);
  setMetadataFor(WriteMode, 'WriteMode', classMeta, Enum);
  setMetadataFor(AbstractJsonLexer, 'AbstractJsonLexer', classMeta);
  setMetadataFor(CharMappings, 'CharMappings', objectMeta);
  setMetadataFor(StringJsonLexer, 'StringJsonLexer', classMeta, AbstractJsonLexer);
  setMetadataFor(JsonToStringWriter, 'JsonToStringWriter', classMeta, VOID, VOID, JsonToStringWriter);
  //endregion
  function Default() {
    Default_instance = this;
    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Json(configuration, serializersModule) {
    Default_getInstance();
    this.q12_1 = configuration;
    this.r12_1 = serializersModule;
    this.s12_1 = new DescriptorSchemaCache();
  }
  protoOf(Json).jm = function () {
    return this.r12_1;
  };
  protoOf(Json).lj = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.u12();
    }
  };
  protoOf(Json).mj = function (deserializer, string) {
    var lexer = new StringJsonLexer(string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.ii(), null);
    var result = input.tl(deserializer);
    lexer.h13();
    return result;
  };
  function Json_0(from, builderAction) {
    from = from === VOID ? Default_getInstance() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.lr();
    return new JsonImpl(conf, builder.y13_1);
  }
  function JsonBuilder(json) {
    this.i13_1 = json.q12_1.z13_1;
    this.j13_1 = json.q12_1.e14_1;
    this.k13_1 = json.q12_1.a14_1;
    this.l13_1 = json.q12_1.b14_1;
    this.m13_1 = json.q12_1.c14_1;
    this.n13_1 = json.q12_1.d14_1;
    this.o13_1 = json.q12_1.f14_1;
    this.p13_1 = json.q12_1.g14_1;
    this.q13_1 = json.q12_1.h14_1;
    this.r13_1 = json.q12_1.i14_1;
    this.s13_1 = json.q12_1.o14_1;
    this.t13_1 = json.q12_1.j14_1;
    this.u13_1 = json.q12_1.k14_1;
    this.v13_1 = json.q12_1.l14_1;
    this.w13_1 = json.q12_1.m14_1;
    this.x13_1 = json.q12_1.n14_1;
    this.y13_1 = json.jm();
  }
  protoOf(JsonBuilder).lr = function () {
    if (this.q13_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.r13_1 === 'type')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.s13_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
    }
    if (!this.n13_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.o13_1 === '    ')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_1 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
    } else if (!(this.o13_1 === '    ')) {
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var indexedObject = this.o13_1;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(indexedObject)) {
          var element = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
          if (!(((element === _Char___init__impl__6a9atx(32) ? true : element === _Char___init__impl__6a9atx(9)) ? true : element === _Char___init__impl__6a9atx(13)) ? true : element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$4 = false;
            break $l$block;
          }
        }
        tmp$ret$4 = true;
      }
      var allWhitespaces = tmp$ret$4;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!allWhitespaces) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.o13_1;
        throw IllegalArgumentException_init_$Create$(toString(message_2));
      }
    }
    return new JsonConfiguration(this.i13_1, this.k13_1, this.l13_1, this.m13_1, this.n13_1, this.j13_1, this.o13_1, this.p13_1, this.q13_1, this.r13_1, this.t13_1, this.u13_1, this.v13_1, this.w13_1, this.x13_1, this.s13_1);
  };
  function validateConfiguration($this) {
    if (equals($this.jm(), EmptySerializersModule()))
      return Unit_instance;
    var collector = new PolymorphismValidator($this.q12_1.h14_1, $this.q12_1.i14_1);
    $this.jm().z11(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, classDiscriminatorMode) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    this.z13_1 = encodeDefaults;
    this.a14_1 = ignoreUnknownKeys;
    this.b14_1 = isLenient;
    this.c14_1 = allowStructuredMapKeys;
    this.d14_1 = prettyPrint;
    this.e14_1 = explicitNulls;
    this.f14_1 = prettyPrintIndent;
    this.g14_1 = coerceInputValues;
    this.h14_1 = useArrayPolymorphism;
    this.i14_1 = classDiscriminator;
    this.j14_1 = allowSpecialFloatingPointValues;
    this.k14_1 = useAlternativeNames;
    this.l14_1 = namingStrategy;
    this.m14_1 = decodeEnumsCaseInsensitive;
    this.n14_1 = allowTrailingComma;
    this.o14_1 = classDiscriminatorMode;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.z13_1 + ', ignoreUnknownKeys=' + this.a14_1 + ', isLenient=' + this.b14_1 + ', ' + ('allowStructuredMapKeys=' + this.c14_1 + ', prettyPrint=' + this.d14_1 + ', explicitNulls=' + this.e14_1 + ', ') + ("prettyPrintIndent='" + this.f14_1 + "', coerceInputValues=" + this.g14_1 + ', useArrayPolymorphism=' + this.h14_1 + ', ') + ("classDiscriminator='" + this.i14_1 + "', allowSpecialFloatingPointValues=" + this.j14_1 + ', ') + ('useAlternativeNames=' + this.k14_1 + ', namingStrategy=' + this.l14_1 + ', decodeEnumsCaseInsensitive=' + this.m14_1 + ', ') + ('allowTrailingComma=' + this.n14_1 + ', classDiscriminatorMode=' + this.o14_1 + ')');
  };
  var ClassDiscriminatorMode_NONE_instance;
  var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
  var ClassDiscriminatorMode_POLYMORPHIC_instance;
  var ClassDiscriminatorMode_entriesInitialized;
  function ClassDiscriminatorMode_initEntries() {
    if (ClassDiscriminatorMode_entriesInitialized)
      return Unit_instance;
    ClassDiscriminatorMode_entriesInitialized = true;
    ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
    ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
    ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
  }
  function ClassDiscriminatorMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ClassDiscriminatorMode_NONE_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_NONE_instance;
  }
  function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_POLYMORPHIC_instance;
  }
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion() {
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    return Companion_instance_0;
  }
  function JsonElement() {
  }
  function Companion_0() {
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    return Companion_instance_1;
  }
  function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
    // Inline function 'kotlin.collections.component1' call
    var k = _name_for_destructuring_parameter_0__wldtmu.e2();
    // Inline function 'kotlin.collections.component2' call
    var v = _name_for_destructuring_parameter_0__wldtmu.f2();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
    printQuoted(this_0, k);
    this_0.j5(_Char___init__impl__6a9atx(58));
    this_0.h5(v);
    return this_0.toString();
  }
  function JsonObject(content) {
    JsonElement.call(this);
    this.r14_1 = content;
  }
  protoOf(JsonObject).b2 = function () {
    return this.r14_1.b2();
  };
  protoOf(JsonObject).z1 = function () {
    return this.r14_1.z1();
  };
  protoOf(JsonObject).n = function () {
    return this.r14_1.n();
  };
  protoOf(JsonObject).a2 = function () {
    return this.r14_1.a2();
  };
  protoOf(JsonObject).s14 = function (key) {
    return this.r14_1.j2(key);
  };
  protoOf(JsonObject).j2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.s14((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).t14 = function (key) {
    return this.r14_1.m2(key);
  };
  protoOf(JsonObject).m2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.t14((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).b1 = function () {
    return this.r14_1.b1();
  };
  protoOf(JsonObject).equals = function (other) {
    return equals(this.r14_1, other);
  };
  protoOf(JsonObject).hashCode = function () {
    return hashCode(this.r14_1);
  };
  protoOf(JsonObject).toString = function () {
    var tmp = this.r14_1.b2();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.v14_1.f2();
  }
  function JsonNull$_anonymous__enib48() {
    return JsonNullSerializer_getInstance();
  }
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.u14_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v14_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
  }
  protoOf(JsonNull).w14 = function () {
    return this.u14_1;
  };
  protoOf(JsonNull).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(JsonNull).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function Companion_1() {
  }
  var Companion_instance_2;
  function Companion_getInstance_6() {
    return Companion_instance_2;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.w14();
  };
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.y14_1 = isString;
    this.z14_1 = coerceToInlineType;
    this.a15_1 = toString(body);
    if (!(this.z14_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.z14_1.ak()) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(JsonLiteral).w14 = function () {
    return this.a15_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.y14_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(this_0, this.a15_1);
      tmp = this_0.toString();
    } else {
      tmp = this.a15_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.y14_1 === other.y14_1))
      return false;
    if (!(this.a15_1 === other.a15_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.y14_1);
    result = imul(31, result) + getStringHashCode(this.a15_1) | 0;
    return result;
  };
  function Companion_2() {
  }
  var Companion_instance_3;
  function Companion_getInstance_7() {
    return Companion_instance_3;
  }
  function JsonArray(content) {
    JsonElement.call(this);
    this.b15_1 = content;
  }
  protoOf(JsonArray).n = function () {
    return this.b15_1.n();
  };
  protoOf(JsonArray).c15 = function (element) {
    return this.b15_1.z(element);
  };
  protoOf(JsonArray).z = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.c15(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).d15 = function (elements) {
    return this.b15_1.a1(elements);
  };
  protoOf(JsonArray).a1 = function (elements) {
    return this.d15(elements);
  };
  protoOf(JsonArray).f1 = function (index) {
    return this.b15_1.f1(index);
  };
  protoOf(JsonArray).b1 = function () {
    return this.b15_1.b1();
  };
  protoOf(JsonArray).u = function () {
    return this.b15_1.u();
  };
  protoOf(JsonArray).q1 = function (index) {
    return this.b15_1.q1(index);
  };
  protoOf(JsonArray).equals = function (other) {
    return equals(this.b15_1, other);
  };
  protoOf(JsonArray).hashCode = function () {
    return hashCode(this.b15_1);
  };
  protoOf(JsonArray).toString = function () {
    return joinToString(this.b15_1, ',', '[', ']');
  };
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull_0(_this__u8e3s4.w14());
  }
  function get_int(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlinx.serialization.json.mapExceptions' call
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.<get-int>.<anonymous>' call
      tmp = (new StringJsonLexer(_this__u8e3s4.w14())).e15();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof JsonDecodingException) {
        var e = $p;
        throw NumberFormatException_init_$Create$(e.message);
      } else {
        throw $p;
      }
    }
    var result = tmp;
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = numberRangeToNumber(IntCompanionObject_instance.MIN_VALUE, IntCompanionObject_instance.MAX_VALUE);
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result))
      throw NumberFormatException_init_$Create$(_this__u8e3s4.w14() + ' is not an Int');
    return result.t8();
  }
  function get_long(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlinx.serialization.json.mapExceptions' call
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.<get-long>.<anonymous>' call
      tmp = (new StringJsonLexer(_this__u8e3s4.w14())).e15();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof JsonDecodingException) {
        var e = $p;
        throw NumberFormatException_init_$Create$(e.message);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlin.text.toFloat' call
    var this_0 = _this__u8e3s4.w14();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return toDouble(this_0);
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.w14());
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.w14();
    }
    return tmp;
  }
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$('Element ' + getKClassFromExpression(_this__u8e3s4) + ' is not a ' + element);
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
    }
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.wi('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.wi('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.wi('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.wi('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.wi('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().f15_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().g15_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().h15_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().i15_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().j15_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.k15_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).ii = function () {
    return this.k15_1;
  };
  protoOf(JsonElementSerializer).l15 = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.mn(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.mn(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.mn(JsonArraySerializer_getInstance(), value);
        }
      }
    }
  };
  protoOf(JsonElementSerializer).ji = function (encoder, value) {
    return this.l15(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).ki = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.q14();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.m15_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).ii();
    this.n15_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).yj = function () {
    return this.m15_1.yj();
  };
  protoOf(JsonObjectDescriptor).zj = function () {
    return this.m15_1.zj();
  };
  protoOf(JsonObjectDescriptor).ak = function () {
    return this.m15_1.ak();
  };
  protoOf(JsonObjectDescriptor).uj = function () {
    return this.m15_1.uj();
  };
  protoOf(JsonObjectDescriptor).bk = function () {
    return this.m15_1.bk();
  };
  protoOf(JsonObjectDescriptor).ck = function (index) {
    return this.m15_1.ck(index);
  };
  protoOf(JsonObjectDescriptor).dk = function (index) {
    return this.m15_1.dk(index);
  };
  protoOf(JsonObjectDescriptor).ek = function (name) {
    return this.m15_1.ek(name);
  };
  protoOf(JsonObjectDescriptor).fk = function (index) {
    return this.m15_1.fk(index);
  };
  protoOf(JsonObjectDescriptor).gk = function (index) {
    return this.m15_1.gk(index);
  };
  protoOf(JsonObjectDescriptor).jj = function () {
    return this.n15_1;
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.i15_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).ii = function () {
    return this.i15_1;
  };
  protoOf(JsonObjectSerializer).o15 = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).ji(encoder, value);
  };
  protoOf(JsonObjectSerializer).ji = function (encoder, value) {
    return this.o15(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).ki = function (decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).ki(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.p15_1 = ListSerializer(JsonElementSerializer_getInstance()).ii();
    this.q15_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).yj = function () {
    return this.p15_1.yj();
  };
  protoOf(JsonArrayDescriptor).zj = function () {
    return this.p15_1.zj();
  };
  protoOf(JsonArrayDescriptor).ak = function () {
    return this.p15_1.ak();
  };
  protoOf(JsonArrayDescriptor).uj = function () {
    return this.p15_1.uj();
  };
  protoOf(JsonArrayDescriptor).bk = function () {
    return this.p15_1.bk();
  };
  protoOf(JsonArrayDescriptor).ck = function (index) {
    return this.p15_1.ck(index);
  };
  protoOf(JsonArrayDescriptor).dk = function (index) {
    return this.p15_1.dk(index);
  };
  protoOf(JsonArrayDescriptor).ek = function (name) {
    return this.p15_1.ek(name);
  };
  protoOf(JsonArrayDescriptor).fk = function (index) {
    return this.p15_1.fk(index);
  };
  protoOf(JsonArrayDescriptor).gk = function (index) {
    return this.p15_1.gk(index);
  };
  protoOf(JsonArrayDescriptor).jj = function () {
    return this.q15_1;
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.j15_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).ii = function () {
    return this.j15_1;
  };
  protoOf(JsonArraySerializer).r15 = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).ji(encoder, value);
  };
  protoOf(JsonArraySerializer).ji = function (encoder, value) {
    return this.r15(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).ki = function (decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).ki(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.f15_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).ii = function () {
    return this.f15_1;
  };
  protoOf(JsonPrimitiveSerializer).s15 = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.mn(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.mn(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).ji = function (encoder, value) {
    return this.s15(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).ki = function (decoder) {
    var result = asJsonDecoder(decoder).q14();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + getKClassFromExpression(result), toString(result));
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.g15_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).ii = function () {
    return this.g15_1;
  };
  protoOf(JsonNullSerializer).t15 = function (encoder, value) {
    verify(encoder);
    encoder.pm();
  };
  protoOf(JsonNullSerializer).ji = function (encoder, value) {
    return this.t15(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).ki = function (decoder) {
    verify_0(decoder);
    if (decoder.fl()) {
      throw new JsonDecodingException("Expected 'null' literal");
    }
    decoder.gl();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.h15_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).ii = function () {
    return this.h15_1;
  };
  protoOf(JsonLiteralSerializer).u15 = function (encoder, value) {
    verify(encoder);
    if (value.y14_1) {
      return encoder.ym(value.a15_1);
    }
    if (!(value.z14_1 == null)) {
      return encoder.an(value.z14_1).ym(value.a15_1);
    }
    var tmp0_safe_receiver = toLongOrNull(value.a15_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.um(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.a15_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.contracts.contract' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).qh_1;
      var tmp_1 = encoder.an(serializer_0(Companion_getInstance()).ii());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.um(tmp$ret$1);
      return Unit_instance;
    }
    var tmp2_safe_receiver = toDoubleOrNull(value.a15_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.wm(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toBooleanStrictOrNull(value.a15_1);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.qm(tmp3_safe_receiver);
    }
    encoder.ym(value.a15_1);
  };
  protoOf(JsonLiteralSerializer).ji = function (encoder, value) {
    return this.u15(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).ki = function (decoder) {
    var result = asJsonDecoder(decoder).q14();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + getKClassFromExpression(result), toString(result));
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + getKClassFromExpression(_this__u8e3s4)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + getKClassFromExpression(_this__u8e3s4)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.v15_1;
    original$factory();
    return this_0.f2();
  }
  function defer$1($deferred) {
    this.v15_1 = lazy_0($deferred);
  }
  protoOf(defer$1).jj = function () {
    return _get_original__l7ku1m(this).jj();
  };
  protoOf(defer$1).bk = function () {
    return _get_original__l7ku1m(this).bk();
  };
  protoOf(defer$1).zj = function () {
    return _get_original__l7ku1m(this).zj();
  };
  protoOf(defer$1).fk = function (index) {
    return _get_original__l7ku1m(this).fk(index);
  };
  protoOf(defer$1).ek = function (name) {
    return _get_original__l7ku1m(this).ek(name);
  };
  protoOf(defer$1).ck = function (index) {
    return _get_original__l7ku1m(this).ck(index);
  };
  protoOf(defer$1).dk = function (index) {
    return _get_original__l7ku1m(this).dk(index);
  };
  protoOf(defer$1).gk = function (index) {
    return _get_original__l7ku1m(this).gk(index);
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original__l7ku1m(receiver);
    }, null);
  }
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.w15_1 = writer;
    this.x15_1 = true;
  }
  protoOf(Composer).y15 = function () {
    this.x15_1 = true;
  };
  protoOf(Composer).z15 = function () {
    return Unit_instance;
  };
  protoOf(Composer).a16 = function () {
    this.x15_1 = false;
  };
  protoOf(Composer).b16 = function () {
    this.x15_1 = false;
  };
  protoOf(Composer).c16 = function () {
    return Unit_instance;
  };
  protoOf(Composer).d16 = function (v) {
    return this.w15_1.e16(v);
  };
  protoOf(Composer).f16 = function (v) {
    return this.w15_1.g16(v);
  };
  protoOf(Composer).h16 = function (v) {
    return this.w15_1.g16(v.toString());
  };
  protoOf(Composer).i16 = function (v) {
    return this.w15_1.g16(v.toString());
  };
  protoOf(Composer).j16 = function (v) {
    return this.w15_1.k16(toLong(v));
  };
  protoOf(Composer).l16 = function (v) {
    return this.w15_1.k16(toLong(v));
  };
  protoOf(Composer).m16 = function (v) {
    return this.w15_1.k16(toLong(v));
  };
  protoOf(Composer).n16 = function (v) {
    return this.w15_1.k16(v);
  };
  protoOf(Composer).o16 = function (v) {
    return this.w15_1.g16(v.toString());
  };
  protoOf(Composer).p16 = function (value) {
    return this.w15_1.q16(value);
  };
  function Composer_0(sb, json) {
    return json.q12_1.d14_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.t16_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).m16 = function (v) {
    if (this.t16_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.p16(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.f16(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).n16 = function (v) {
    if (this.t16_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.p16(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.f16(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).j16 = function (v) {
    if (this.t16_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.p16(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.f16(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).l16 = function (v) {
    if (this.t16_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.p16(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.f16(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.w16_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).p16 = function (value) {
    if (this.w16_1) {
      protoOf(Composer).p16.call(this, value);
    } else {
      protoOf(Composer).f16.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.z16_1 = json;
    this.a17_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).y15 = function () {
    this.x15_1 = true;
    this.a17_1 = this.a17_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).z15 = function () {
    this.a17_1 = this.a17_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).a16 = function () {
    this.x15_1 = false;
    this.f16('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.a17_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.f16(this.z16_1.q12_1.f14_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).b16 = function () {
    if (this.x15_1)
      this.x15_1 = false;
    else {
      this.a16();
    }
  };
  protoOf(ComposerWithPrettyPrint).c16 = function () {
    this.d16(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent($this, descriptor, index) {
    $this.c17_1 = !descriptor.gk(index) ? descriptor.dk(index).uj() : false;
    return $this.c17_1;
  }
  function JsonElementMarker$readIfAbsent$ref($boundThis) {
    var l = function (p0, p1) {
      return readIfAbsent($boundThis, p0, p1);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.b17_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.c17_1 = false;
  }
  protoOf(JsonElementMarker).zr = function (index) {
    this.b17_1.zr(index);
  };
  protoOf(JsonElementMarker).as = function () {
    return this.b17_1.as();
  };
  function invalidTrailingComma(_this__u8e3s4, entity) {
    entity = entity === VOID ? 'object' : entity;
    _this__u8e3s4.d17('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.d13_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingCommas = true' in 'Json {}' builder to support them.");
  }
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.e17('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, get_specialFlowingValuesHint());
  }
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.jj() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.bk() + "'.\n") + get_allowStructuredMapKeysHint());
  }
  function JsonDecodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, message + '\nJSON input: ' + minify(input, offset));
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function UnknownKeyException(key, input) {
    return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + (get_ignoreUnknownKeysHint() + '\n') + ('Current input: ' + minify(input)));
  }
  function InvalidFloatingPointEncoded(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + (get_specialFlowingValuesHint() + '\n') + ('Current output: ' + minify(output)));
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  function unexpectedFpErrorMessage(value, key, output) {
    return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + (get_specialFlowingValuesHint() + '\n') + ('Current output: ' + minify(output));
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    // Inline function 'kotlin.text.substring' call
    var startIndex = coerceAtLeast(start_0, 0);
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    if (decodeCaseInsensitive(json, _this__u8e3s4)) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = name.toLowerCase();
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
    }
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
    var index = _this__u8e3s4.ek(name);
    if (!(index === -3))
      return index;
    if (!json.q12_1.k14_1)
      return index;
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    if (index === -3)
      throw SerializationException_init_$Create$(_this__u8e3s4.jj() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.fk(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.bk(), CLASS_getInstance()) ? json.q12_1.l14_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.g17(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return _this__u8e3s4.q12_1.m14_1 ? equals(descriptor.bk(), ENUM_getInstance()) : false;
  }
  function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).m2(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = -3;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.g17(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var builder = LinkedHashMap_init_$Create$();
    var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
    var strategyForClasses = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.zj();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.filterIsInstance' call
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var this_0 = _this__u8e3s4.ck(i);
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator = this_0.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.w();
          if (element instanceof JsonNames) {
            destination.r(element);
          }
        }
        var tmp1_safe_receiver = singleOrNull(destination);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h17_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = tmp2_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp2_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
            var tmp;
            if (useLowercaseEnums) {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp = element_0.toLowerCase();
            } else {
              tmp = element_0;
            }
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
          }
        }
        var tmp_0;
        if (useLowercaseEnums) {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = _this__u8e3s4.fk(i).toLowerCase();
        } else if (!(strategyForClasses == null)) {
          tmp_0 = strategyForClasses.i17(_this__u8e3s4, i, _this__u8e3s4.fk(i));
        } else {
          tmp_0 = null;
        }
        var nameToPut = tmp_0;
        if (nameToPut == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_1;
    if (builder.b1()) {
      // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
      tmp_1 = emptyMap();
    } else {
      tmp_1 = builder;
    }
    return tmp_1;
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    var entity = equals($this_buildDeserializationNamesMap.bk(), ENUM_getInstance()) ? 'enum value' : 'property';
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(_this__u8e3s4, Map) ? _this__u8e3s4 : THROW_CCE()).j2(name)) {
      throw new JsonException("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.fk(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.fk(getValue(_this__u8e3s4, name)) + ' in ' + $this_buildDeserializationNamesMap));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.c2(name, index);
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.zj();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.fk(tmp_2);
        tmp_1[tmp_2] = $strategy.i17($this_serializationNamesIndices, tmp_2, baseName);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key();
      JsonSerializationNamesKey = new Key();
    }
  }
  function Tombstone() {
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    return Tombstone_instance;
  }
  function resize($this) {
    var newSize = imul($this.l17_1, 2);
    $this.j17_1 = copyOf($this.j17_1, newSize);
    $this.k17_1 = copyOf_0($this.k17_1, newSize);
  }
  function JsonPath() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.j17_1 = fillArrayVal(Array(8), null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.k17_1 = tmp_2;
    this.l17_1 = -1;
  }
  protoOf(JsonPath).m17 = function (sd) {
    this.l17_1 = this.l17_1 + 1 | 0;
    var depth = this.l17_1;
    if (depth === this.j17_1.length) {
      resize(this);
    }
    this.j17_1[depth] = sd;
  };
  protoOf(JsonPath).n17 = function (index) {
    this.k17_1[this.l17_1] = index;
  };
  protoOf(JsonPath).o17 = function (key) {
    var tmp;
    if (!(this.k17_1[this.l17_1] === -2)) {
      this.l17_1 = this.l17_1 + 1 | 0;
      tmp = this.l17_1 === this.j17_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.j17_1[this.l17_1] = key;
    this.k17_1[this.l17_1] = -2;
  };
  protoOf(JsonPath).p17 = function () {
    if (this.k17_1[this.l17_1] === -2) {
      this.j17_1[this.l17_1] = Tombstone_instance;
    }
  };
  protoOf(JsonPath).q17 = function () {
    var depth = this.l17_1;
    if (this.k17_1[depth] === -2) {
      this.k17_1[depth] = -1;
      this.l17_1 = this.l17_1 - 1 | 0;
    }
    if (!(this.l17_1 === -1)) {
      this.l17_1 = this.l17_1 - 1 | 0;
    }
  };
  protoOf(JsonPath).r17 = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
    this_0.i5('$');
    // Inline function 'kotlin.repeat' call
    var times = this.l17_1 + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
        var element = this.j17_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.bk(), LIST_getInstance())) {
            if (!(this.k17_1[index] === -1)) {
              this_0.i5('[');
              this_0.r7(this.k17_1[index]);
              this_0.i5(']');
            }
          } else {
            var idx = this.k17_1[index];
            if (idx >= 0) {
              this_0.i5('.');
              this_0.i5(element.fk(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.i5('[');
            this_0.i5("'");
            this_0.h5(element);
            this_0.i5("'");
            this_0.i5(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  };
  protoOf(JsonPath).toString = function () {
    return this.r17();
  };
  function encodeByWriter(json, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = get_entries().n();
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
    encoder.mn(serializer, value);
  }
  function readObject($this) {
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.a18_1.e18(get_TC_BEGIN_OBJ());
    if ($this.a18_1.f18() === get_TC_COMMA()) {
      $this.a18_1.e17('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.linkedMapOf' call
    var result = LinkedHashMap_init_$Create$();
    $l$loop: while ($this.a18_1.g18()) {
      var key = $this.b18_1 ? $this.a18_1.i18() : $this.a18_1.h18();
      $this.a18_1.e18(get_TC_COLON());
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
      var element = $this.j18();
      // Inline function 'kotlin.collections.set' call
      result.c2(key, element);
      lastToken = $this.a18_1.k18();
      var tmp0_subject = lastToken;
      if (tmp0_subject !== get_TC_COMMA())
        if (tmp0_subject === get_TC_END_OBJ())
          break $l$loop;
        else {
          $this.a18_1.e17('Expected end of the object or comma');
        }
    }
    if (lastToken === get_TC_BEGIN_OBJ()) {
      $this.a18_1.e18(get_TC_END_OBJ());
    } else if (lastToken === get_TC_COMMA()) {
      if (!$this.c18_1) {
        invalidTrailingComma($this.a18_1);
      }
      $this.a18_1.e18(get_TC_END_OBJ());
    }
    return new JsonObject(result);
  }
  function readObject_0(_this__u8e3s4, $this, $completion) {
    var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  }
  function readArray($this) {
    var lastToken = $this.a18_1.k18();
    if ($this.a18_1.f18() === get_TC_COMMA()) {
      $this.a18_1.e17('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    while ($this.a18_1.g18()) {
      var element = $this.j18();
      result.r(element);
      lastToken = $this.a18_1.k18();
      if (!(lastToken === get_TC_COMMA())) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var this_0 = $this.a18_1;
        var condition = lastToken === get_TC_END_LIST();
        var position = this_0.d13_1;
        if (!condition) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
          var tmp$ret$1 = 'Expected end of the array or comma';
          this_0.e17(tmp$ret$1, position);
        }
      }
    }
    if (lastToken === get_TC_BEGIN_LIST()) {
      $this.a18_1.e18(get_TC_END_LIST());
    } else if (lastToken === get_TC_COMMA()) {
      if (!$this.c18_1) {
        invalidTrailingComma($this.a18_1, 'array');
      }
      $this.a18_1.e18(get_TC_END_LIST());
    }
    return new JsonArray(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.b18_1 ? true : !isString) {
      tmp = $this.a18_1.i18();
    } else {
      tmp = $this.a18_1.h18();
    }
    var string = tmp;
    if (!isString ? string === get_NULL() : false)
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.h19_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).m19 = function ($this$$receiver, it, $completion) {
    var tmp = this.n19($this$$receiver, it, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).hg = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.m19(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 3;
            this.k19_1 = this.h19_1.a18_1.f18();
            if (this.k19_1 === get_TC_STRING()) {
              this.l19_1 = readValue(this.h19_1, true);
              this.la_1 = 2;
              continue $sm;
            } else {
              if (this.k19_1 === get_TC_OTHER()) {
                this.l19_1 = readValue(this.h19_1, false);
                this.la_1 = 2;
                continue $sm;
              } else {
                if (this.k19_1 === get_TC_BEGIN_OBJ()) {
                  this.la_1 = 1;
                  suspendResult = readObject_0(this.i19_1, this.h19_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.k19_1 === get_TC_BEGIN_LIST()) {
                    this.l19_1 = readArray(this.h19_1);
                    this.la_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.h19_1.a18_1.e17("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.l19_1 = suspendResult;
            this.la_1 = 2;
            continue $sm;
          case 2:
            return this.l19_1;
          case 3:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 3) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).n19 = function ($this$$receiver, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.h19_1, completion);
    i.i19_1 = $this$$receiver;
    i.j19_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    var l = function ($this$$receiver, it, $completion) {
      return i.m19($this$$receiver, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t18_1 = _this__u8e3s4;
    this.u18_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$0).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 5;
            var tmp_0 = this;
            tmp_0.v18_1 = this.t18_1;
            this.w18_1 = this.v18_1.a18_1.e18(get_TC_BEGIN_OBJ());
            if (this.v18_1.a18_1.f18() === get_TC_COMMA()) {
              this.v18_1.a18_1.e17('Unexpected leading comma');
            }

            var tmp_1 = this;
            tmp_1.x18_1 = LinkedHashMap_init_$Create$();
            this.la_1 = 1;
            continue $sm;
          case 1:
            if (!this.v18_1.a18_1.g18()) {
              this.la_1 = 4;
              continue $sm;
            }

            this.y18_1 = this.v18_1.b18_1 ? this.v18_1.a18_1.i18() : this.v18_1.a18_1.h18();
            this.v18_1.a18_1.e18(get_TC_COLON());
            this.la_1 = 2;
            suspendResult = this.u18_1.zf(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            var this_0 = this.x18_1;
            var key = this.y18_1;
            this_0.c2(key, element);
            this.w18_1 = this.v18_1.a18_1.k18();
            var tmp0_subject = this.w18_1;
            if (tmp0_subject === get_TC_COMMA()) {
              this.la_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === get_TC_END_OBJ()) {
                this.la_1 = 4;
                continue $sm;
              } else {
                this.v18_1.a18_1.e17('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.la_1 = 1;
            continue $sm;
          case 4:
            if (this.w18_1 === get_TC_BEGIN_OBJ()) {
              this.v18_1.a18_1.e18(get_TC_END_OBJ());
            } else if (this.w18_1 === get_TC_COMMA()) {
              if (!this.v18_1.c18_1) {
                invalidTrailingComma(this.v18_1.a18_1);
              }
              this.v18_1.a18_1.e18(get_TC_END_OBJ());
            }

            return new JsonObject(this.x18_1);
          case 5:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 5) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.a18_1 = lexer;
    this.b18_1 = configuration.b14_1;
    this.c18_1 = configuration.n14_1;
    this.d18_1 = 0;
  }
  protoOf(JsonTreeReader).j18 = function () {
    var token = this.a18_1.f18();
    var tmp;
    if (token === get_TC_STRING()) {
      tmp = readValue(this, true);
    } else if (token === get_TC_OTHER()) {
      tmp = readValue(this, false);
    } else if (token === get_TC_BEGIN_OBJ()) {
      var tmp_0;
      this.d18_1 = this.d18_1 + 1 | 0;
      if (this.d18_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.d18_1 = this.d18_1 - 1 | 0;
      tmp = result;
    } else if (token === get_TC_BEGIN_LIST()) {
      tmp = readArray(this);
    } else {
      this.a18_1.e17('Cannot read Json element because of unexpected ' + tokenDescription(token));
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var tmp0_iterator = _this__u8e3s4.yj().u();
    while (tmp0_iterator.v()) {
      var annotation = tmp0_iterator.w();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.o19_1;
    }
    return json.q12_1.i14_1;
  }
  function decodeSerializableValuePolymorphic(_this__u8e3s4, deserializer) {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.p14().q12_1.h14_1;
    }
    if (tmp) {
      return deserializer.ki(_this__u8e3s4);
    }
    var discriminator = classDiscriminator(deserializer.ii(), _this__u8e3s4.p14());
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = _this__u8e3s4.q14();
    var descriptor = deserializer.ii();
    if (!(value instanceof JsonObject)) {
      throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.jj() + ', but had ' + getKClassFromExpression(value));
    }
    var jsonTree = value;
    var tmp0_safe_receiver = jsonTree.t14(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
    var tmp_0;
    try {
      tmp_0 = findPolymorphicSerializer(deserializer, _this__u8e3s4, type);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof SerializationException) {
        var it = $p;
        throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
      } else {
        throw $p;
      }
    }
    var tmp_2 = tmp_0;
    var actualSerializer = isInterface(tmp_2, DeserializationStrategy) ? tmp_2 : THROW_CCE();
    return readPolymorphicJson(_this__u8e3s4.p14(), discriminator, jsonTree, actualSerializer);
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_instance;
    if (jsonCachedSerialNames(actualSerializer.ii()).z(classDiscriminator)) {
      var baseName = serializer.ii().jj();
      var actualName = actualSerializer.ii().jj();
      // Inline function 'kotlin.error' call
      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
  }
  function validateIfSealed$accessor$1ad0flx(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function checkKind_0($this, descriptor, actualClass) {
    var kind = descriptor.bk();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.z5() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.p19_1)
      return Unit_instance;
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) ? true : equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.z5() + ' of kind ' + kind + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last = descriptor.zj();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.fk(i);
        if (name === $this.q19_1) {
          throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + actualClass + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }
      }
       while (inductionVariable < last);
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this.p19_1 = useArrayPolymorphism;
    this.q19_1 = discriminator;
  }
  protoOf(PolymorphismValidator).h12 = function (kClass, provider) {
  };
  protoOf(PolymorphismValidator).k12 = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.ii();
    checkKind_0(this, descriptor, actualClass);
    if (!this.p19_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  };
  protoOf(PolymorphismValidator).l12 = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(PolymorphismValidator).m12 = function (baseClass, defaultDeserializerProvider) {
  };
  function Key() {
  }
  function DescriptorSchemaCache() {
    this.f17_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).r19 = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.f17_1;
    var value_0 = this_0.m2(descriptor);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      var answer = createMapForCache(2);
      this_0.c2(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var this_1 = tmp;
    var key_0 = key instanceof Key ? key : THROW_CCE();
    var value_1 = !(value == null) ? value : THROW_CCE();
    this_1.c2(key_0, value_1);
  };
  protoOf(DescriptorSchemaCache).g17 = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.s19(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.r19(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).s19 = function (descriptor, key) {
    var tmp0_safe_receiver = this.f17_1.m2(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.m2(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.t19_1 = discriminatorToSkip;
  }
  function trySkip(_this__u8e3s4, $this, unknownKey) {
    if (_this__u8e3s4 == null)
      return false;
    if (_this__u8e3s4.t19_1 === unknownKey) {
      _this__u8e3s4.t19_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    $l$loop: while (true) {
      var tmp = $this.lm(descriptor);
      if (!!(tmp === -1)) {
        break $l$loop;
      }
    }
  }
  function checkLeadingComma($this) {
    if ($this.x12_1.f18() === get_TC_COMMA()) {
      $this.x12_1.e17('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.z12_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.z12_1 === -1)) {
        hasComma = $this.x12_1.v19();
      }
    } else {
      $this.x12_1.u19(get_COLON());
    }
    var tmp;
    if ($this.x12_1.g18()) {
      if (decodingKey) {
        if ($this.z12_1 === -1) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var this_0 = $this.x12_1;
          var condition = !hasComma;
          var position = this_0.d13_1;
          if (!condition) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$0 = 'Unexpected leading comma';
            this_0.e17(tmp$ret$0, position);
          }
        } else {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var this_1 = $this.x12_1;
          var condition_0 = hasComma;
          var position_0 = this_1.d13_1;
          if (!condition_0) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$1 = 'Expected comma after the key-value pair';
            this_1.e17(tmp$ret$1, position_0);
          }
        }
      }
      $this.z12_1 = $this.z12_1 + 1 | 0;
      tmp = $this.z12_1;
    } else {
      if (hasComma ? !$this.v12_1.q12_1.n14_1 : false) {
        invalidTrailingComma($this.x12_1);
      }
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp$ret$0;
    $l$block_3: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var this_0 = $this.v12_1;
      if (!descriptor.gk(index)) {
        tmp$ret$0 = false;
        break $l$block_3;
      }
      var elementDescriptor = descriptor.dk(index);
      var tmp;
      if (!elementDescriptor.uj()) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp = $this.x12_1.w19(true);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_3;
      }
      if (equals(elementDescriptor.bk(), ENUM_getInstance())) {
        var tmp_0;
        if (elementDescriptor.uj()) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          tmp_0 = $this.x12_1.w19(false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_3;
        }
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        var tmp0_elvis_lhs = $this.x12_1.x19($this.b13_1.b14_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$0 = false;
          break $l$block_3;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          $this.x12_1.h18();
          tmp$ret$0 = true;
          break $l$block_3;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.x12_1.v19();
    while ($this.x12_1.g18()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.x12_1.u19(get_COLON());
      var index = getJsonNameIndex(descriptor, $this.v12_1, key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this.b13_1.g14_1 ? coerceInputValue($this, descriptor, index) : false) {
          hasComma = $this.x12_1.v19();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.c13_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.zr(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, key);
      }
    }
    if (hasComma ? !$this.v12_1.q12_1.n14_1 : false) {
      invalidTrailingComma($this.x12_1);
    }
    var tmp1_safe_receiver = $this.c13_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.as();
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      tmp_1 = -1;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    return tmp_1;
  }
  function handleUnknown($this, key) {
    if ($this.b13_1.a14_1 ? true : trySkip($this.a13_1, $this, key)) {
      $this.x12_1.z19($this.b13_1.b14_1);
    } else {
      $this.x12_1.y19(key);
    }
    return $this.x12_1.v19();
  }
  function decodeListIndex($this) {
    var hasComma = $this.x12_1.v19();
    var tmp;
    if ($this.x12_1.g18()) {
      if (!($this.z12_1 === -1) ? !hasComma : false) {
        $this.x12_1.e17('Expected end of the array or comma');
      }
      $this.z12_1 = $this.z12_1 + 1 | 0;
      tmp = $this.z12_1;
    } else {
      if (hasComma ? !$this.v12_1.q12_1.n14_1 : false) {
        invalidTrailingComma($this.x12_1, 'array');
      }
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.b13_1.b14_1) {
      tmp = $this.x12_1.b1a();
    } else {
      tmp = $this.x12_1.a1a();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.v12_1 = json;
    this.w12_1 = mode;
    this.x12_1 = lexer;
    this.y12_1 = this.v12_1.jm();
    this.z12_1 = -1;
    this.a13_1 = discriminatorHolder;
    this.b13_1 = this.v12_1.q12_1;
    this.c13_1 = this.b13_1.e14_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).p14 = function () {
    return this.v12_1;
  };
  protoOf(StreamingJsonDecoder).jm = function () {
    return this.y12_1;
  };
  protoOf(StreamingJsonDecoder).q14 = function () {
    return (new JsonTreeReader(this.v12_1.q12_1, this.x12_1)).j18();
  };
  protoOf(StreamingJsonDecoder).tl = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.v12_1.q12_1.h14_1;
      }
      if (tmp) {
        return deserializer.ki(this);
      }
      var discriminator = classDiscriminator(deserializer.ii(), this.v12_1);
      var tmp0_elvis_lhs = this.x12_1.c1a(discriminator, this.b13_1.b14_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return decodeSerializableValuePolymorphic(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var type = tmp_0;
      var tmp_1;
      try {
        tmp_1 = findPolymorphicSerializer(deserializer, this, type);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof SerializationException) {
          var it = $p;
          var message = removeSuffix(substringBefore(ensureNotNull(it.message), _Char___init__impl__6a9atx(10)), '.');
          var hint = substringAfter(ensureNotNull(it.message), _Char___init__impl__6a9atx(10), '');
          this.x12_1.e17(message, VOID, hint);
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      var tmp_3 = tmp_1;
      var actualSerializer = isInterface(tmp_3, DeserializationStrategy) ? tmp_3 : THROW_CCE();
      this.a13_1 = new DiscriminatorHolder(discriminator);
      return actualSerializer.ki(this);
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains_0(ensureNotNull(e.message), 'at path'))
          throw e;
        throw new MissingFieldException(e.pj_1, plus(e.message, ' at path: ') + this.x12_1.e13_1.r17(), e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(StreamingJsonDecoder).ul = function (descriptor) {
    var newMode = switchMode(this.v12_1, descriptor);
    this.x12_1.e13_1.m17(descriptor);
    this.x12_1.u19(newMode.f1a_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.i8_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.v12_1, newMode, this.x12_1, descriptor, this.a13_1);
        break;
      default:
        var tmp_0;
        if (this.w12_1.equals(newMode) ? this.v12_1.q12_1.e14_1 : false) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.v12_1, newMode, this.x12_1, descriptor, this.a13_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).vl = function (descriptor) {
    if (this.v12_1.q12_1.a14_1 ? descriptor.zj() === 0 : false) {
      skipLeftoverElements(this, descriptor);
    }
    if (this.x12_1.v19() ? !this.v12_1.q12_1.n14_1 : false) {
      invalidTrailingComma(this.x12_1, '');
    }
    this.x12_1.u19(this.w12_1.g1a_1);
    this.x12_1.e13_1.q17();
  };
  protoOf(StreamingJsonDecoder).fl = function () {
    var tmp;
    var tmp0_safe_receiver = this.c13_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c17_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.x12_1.h1a();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).gl = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).gm = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.w12_1.equals(WriteMode_MAP_getInstance()) ? (index & 1) === 0 : false;
    if (isMapKey) {
      this.x12_1.e13_1.p17();
    }
    var value = protoOf(AbstractDecoder).gm.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.x12_1.e13_1.o17(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).lm = function (descriptor) {
    var index;
    switch (this.w12_1.i8_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.w12_1.equals(WriteMode_MAP_getInstance())) {
      this.x12_1.e13_1.n17(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).hl = function () {
    return this.x12_1.i1a();
  };
  protoOf(StreamingJsonDecoder).il = function () {
    var value = this.x12_1.e15();
    if (!value.equals(toLong(value.ca()))) {
      this.x12_1.e17("Failed to parse byte for input '" + value.toString() + "'");
    }
    return value.ca();
  };
  protoOf(StreamingJsonDecoder).jl = function () {
    var value = this.x12_1.e15();
    if (!value.equals(toLong(value.da()))) {
      this.x12_1.e17("Failed to parse short for input '" + value.toString() + "'");
    }
    return value.da();
  };
  protoOf(StreamingJsonDecoder).kl = function () {
    var value = this.x12_1.e15();
    if (!value.equals(toLong(value.t8()))) {
      this.x12_1.e17("Failed to parse int for input '" + value.toString() + "'");
    }
    return value.t8();
  };
  protoOf(StreamingJsonDecoder).ll = function () {
    return this.x12_1.e15();
  };
  protoOf(StreamingJsonDecoder).ml = function () {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.x12_1;
      var input = this_0.i18();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.e17("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.v12_1.q12_1.j14_1;
    if (specialFp ? true : isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.x12_1, result);
  };
  protoOf(StreamingJsonDecoder).nl = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.x12_1;
      var input = this_0.i18();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
        tmp$ret$1 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.e17("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.v12_1.q12_1.j14_1;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.x12_1, result);
  };
  protoOf(StreamingJsonDecoder).ol = function () {
    var string = this.x12_1.i18();
    if (!(string.length === 1)) {
      this.x12_1.e17("Expected single char, but got '" + string + "'");
    }
    return charSequenceGet(string, 0);
  };
  protoOf(StreamingJsonDecoder).pl = function () {
    var tmp;
    if (this.b13_1.b14_1) {
      tmp = this.x12_1.b1a();
    } else {
      tmp = this.x12_1.h18();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).rl = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.x12_1, this.v12_1) : protoOf(AbstractDecoder).rl.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).ql = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.v12_1, this.pl(), ' at path ' + this.x12_1.e13_1.r17());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.j1a_1 = lexer;
    this.k1a_1 = json.jm();
  }
  protoOf(JsonDecoderForUnsignedTypes).jm = function () {
    return this.k1a_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).lm = function (descriptor) {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(JsonDecoderForUnsignedTypes).kl = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.j1a_1;
      var input = this_0.i18();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
        // Inline function 'kotlin.UInt.toInt' call
        var this_1 = toUInt(input);
        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.e17("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).ll = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.j1a_1;
      var input = this_0.i18();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = toULong(input);
        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.e17("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).il = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.j1a_1;
      var input = this_0.i18();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
        // Inline function 'kotlin.UByte.toByte' call
        var this_1 = toUByte(input);
        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.e17("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).jl = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.j1a_1;
      var input = this_0.i18();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
        // Inline function 'kotlin.UShort.toShort' call
        var this_1 = toUShort(input);
        tmp$ret$2 = _UShort___get_data__impl__g0245(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.e17("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, descriptor) {
    $this.s17_1.a16();
    $this.ym(ensureNotNull($this.z17_1));
    $this.s17_1.d16(get_COLON());
    $this.s17_1.c16();
    $this.ym(descriptor.jj());
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.s17_1 = composer;
    this.t17_1 = json;
    this.u17_1 = mode;
    this.v17_1 = modeReuseCache;
    this.w17_1 = this.t17_1.jm();
    this.x17_1 = this.t17_1.q12_1;
    this.y17_1 = false;
    this.z17_1 = null;
    var i = this.u17_1.i8_1;
    if (!(this.v17_1 == null)) {
      if (!(this.v17_1[i] === null) ? true : !(this.v17_1[i] === this)) {
        this.v17_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).p14 = function () {
    return this.t17_1;
  };
  protoOf(StreamingJsonEncoder).jm = function () {
    return this.w17_1;
  };
  protoOf(StreamingJsonEncoder).rn = function (descriptor, index) {
    return this.x17_1.z13_1;
  };
  protoOf(StreamingJsonEncoder).mn = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.p14().q12_1.h14_1) {
        serializer.ji(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.p14().q12_1.o14_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.p14().q12_1.o14_1.i8_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call

            var it = serializer.ii().bk();
            tmp_0 = equals(it, CLASS_getInstance()) ? true : equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.ii(), this.p14()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          // Inline function 'kotlin.contracts.contract' call
          if (value == null) {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call
            var message = 'Value for serializer ' + serializer.ii() + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer_0(casted, this, value);
        if (!(baseClassDiscriminator == null)) {
          validateIfSealed$accessor$1ad0flx(serializer, actual, baseClassDiscriminator);
        }
        checkKind(actual.ii().bk());
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
        this.z17_1 = baseClassDiscriminator;
      }
      actualSerializer.ji(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).ul = function (descriptor) {
    var newMode = switchMode(this.t17_1, descriptor);
    if (!(newMode.f1a_1 === get_INVALID())) {
      this.s17_1.d16(newMode.f1a_1);
      this.s17_1.y15();
    }
    if (!(this.z17_1 == null)) {
      encodeTypeInfo(this, descriptor);
      this.z17_1 = null;
    }
    if (this.u17_1.equals(newMode)) {
      return this;
    }
    var tmp0_safe_receiver = this.v17_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.i8_1];
    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.s17_1, this.t17_1, newMode, this.v17_1) : tmp1_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).vl = function (descriptor) {
    if (!(this.u17_1.g1a_1 === get_INVALID())) {
      this.s17_1.z15();
      this.s17_1.b16();
      this.s17_1.d16(this.u17_1.g1a_1);
    }
  };
  protoOf(StreamingJsonEncoder).nm = function (descriptor, index) {
    switch (this.u17_1.i8_1) {
      case 1:
        if (!this.s17_1.x15_1) {
          this.s17_1.d16(get_COMMA());
        }

        this.s17_1.a16();
        break;
      case 2:
        if (!this.s17_1.x15_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.s17_1.d16(get_COMMA());
            this.s17_1.a16();
            tmp_0 = true;
          } else {
            this.s17_1.d16(get_COLON());
            this.s17_1.c16();
            tmp_0 = false;
          }
          tmp.y17_1 = tmp_0;
        } else {
          this.y17_1 = true;
          this.s17_1.a16();
        }

        break;
      case 3:
        if (index === 0)
          this.y17_1 = true;
        if (index === 1) {
          this.s17_1.d16(get_COMMA());
          this.s17_1.c16();
          this.y17_1 = false;
        }

        break;
      default:
        if (!this.s17_1.x15_1) {
          this.s17_1.d16(get_COMMA());
        }

        this.s17_1.a16();
        this.ym(getJsonElementName(descriptor, this.t17_1, index));
        this.s17_1.d16(get_COLON());
        this.s17_1.c16();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).nn = function (descriptor, index, serializer, value) {
    if (!(value == null) ? true : this.x17_1.e14_1) {
      protoOf(AbstractEncoder).nn.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).an = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.s17_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.s17_1;
      } else {
        tmp_0 = new ComposerForUnsignedNumbers(this.s17_1.w15_1, this.y17_1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$1, this.t17_1, this.u17_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.s17_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.s17_1;
      } else {
        tmp_2 = new ComposerForUnquotedLiterals(this.s17_1.w15_1, this.y17_1);
      }
      var tmp$ret$3 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$3, this.t17_1, this.u17_1, null);
    } else {
      tmp = protoOf(AbstractEncoder).an.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).pm = function () {
    this.s17_1.f16(get_NULL());
  };
  protoOf(StreamingJsonEncoder).qm = function (value) {
    if (this.y17_1) {
      this.ym(value.toString());
    } else {
      this.s17_1.o16(value);
    }
  };
  protoOf(StreamingJsonEncoder).rm = function (value) {
    if (this.y17_1) {
      this.ym(value.toString());
    } else {
      this.s17_1.j16(value);
    }
  };
  protoOf(StreamingJsonEncoder).sm = function (value) {
    if (this.y17_1) {
      this.ym(value.toString());
    } else {
      this.s17_1.l16(value);
    }
  };
  protoOf(StreamingJsonEncoder).tm = function (value) {
    if (this.y17_1) {
      this.ym(value.toString());
    } else {
      this.s17_1.m16(value);
    }
  };
  protoOf(StreamingJsonEncoder).um = function (value) {
    if (this.y17_1) {
      this.ym(value.toString());
    } else {
      this.s17_1.n16(value);
    }
  };
  protoOf(StreamingJsonEncoder).vm = function (value) {
    if (this.y17_1) {
      this.ym(value.toString());
    } else {
      this.s17_1.h16(value);
    }
    if (!this.x17_1.j14_1 ? !isFinite(value) : false) {
      throw InvalidFloatingPointEncoded(value, toString(this.s17_1.w15_1));
    }
  };
  protoOf(StreamingJsonEncoder).wm = function (value) {
    if (this.y17_1) {
      this.ym(value.toString());
    } else {
      this.s17_1.i16(value);
    }
    if (!this.x17_1.j14_1 ? !isFinite_0(value) : false) {
      throw InvalidFloatingPointEncoded(value, toString(this.s17_1.w15_1));
    }
  };
  protoOf(StreamingJsonEncoder).xm = function (value) {
    this.ym(toString_0(value));
  };
  protoOf(StreamingJsonEncoder).ym = function (value) {
    return this.s17_1.p16(value);
  };
  protoOf(StreamingJsonEncoder).zm = function (enumDescriptor, index) {
    this.ym(enumDescriptor.fk(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.ak() ? get_unsignedNumberDescriptors().z(_this__u8e3s4) : false;
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.ak() ? equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor()) : false;
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).ii(), serializer_0(Companion_getInstance()).ii(), serializer_2(Companion_getInstance_1()).ii(), serializer_3(Companion_getInstance_2()).ii()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.j5(get_STRING());
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length ? !(get_ESCAPE_STRINGS()[c] == null) : false) {
          _this__u8e3s4.p7(value, lastPos, i);
          _this__u8e3s4.i5(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0)) {
      _this__u8e3s4.p7(value, lastPos, value.length);
    } else {
      _this__u8e3s4.i5(value);
    }
    _this__u8e3s4.j5(get_STRING());
  }
  function toBooleanStrictOrNull_0(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.arrayOfNulls' call
      var this_0 = fillArrayVal(Array(93), null);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString_0(c1) + toString_0(c2) + toString_0(c3) + toString_0(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      this_7[Char__toInt_impl_vasixd(this_8)] = 34;
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(92);
      this_7[Char__toInt_impl_vasixd(this_9)] = 92;
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(9);
      this_7[Char__toInt_impl_vasixd(this_10)] = 116;
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(8);
      this_7[Char__toInt_impl_vasixd(this_11)] = 98;
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(10);
      this_7[Char__toInt_impl_vasixd(this_12)] = 110;
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(13);
      this_7[Char__toInt_impl_vasixd(this_13)] = 114;
      this_7[12] = 102;
      ESCAPE_MARKERS = this_7;
    }
  }
  function unparsedPrimitive($this, primitive) {
    throw JsonDecodingException_0(-1, "Failed to parse literal as '" + primitive + "' value", toString($this.q1a()));
  }
  function asLiteral(_this__u8e3s4, $this, type) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonLiteral ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_1(-1, "Unexpected 'null' literal when non-nullable " + type + ' was expected');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbstractJsonTreeDecoder(json, value) {
    NamedValueDecoder.call(this);
    this.n1a_1 = json;
    this.o1a_1 = value;
    this.p1a_1 = this.p14().q12_1;
  }
  protoOf(AbstractJsonTreeDecoder).p14 = function () {
    return this.n1a_1;
  };
  protoOf(AbstractJsonTreeDecoder).f2 = function () {
    return this.o1a_1;
  };
  protoOf(AbstractJsonTreeDecoder).jm = function () {
    return this.p14().jm();
  };
  protoOf(AbstractJsonTreeDecoder).q1a = function () {
    var tmp0_safe_receiver = this.zz();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
      tmp = this.r1a(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this.f2() : tmp1_elvis_lhs;
  };
  protoOf(AbstractJsonTreeDecoder).q14 = function () {
    return this.q1a();
  };
  protoOf(AbstractJsonTreeDecoder).tl = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  protoOf(AbstractJsonTreeDecoder).a10 = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).ul = function (descriptor) {
    var currentObject = this.q1a();
    var tmp0_subject = descriptor.bk();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.p14();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      if (!(currentObject instanceof JsonArray)) {
        throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonArray) + ' as the serialized body of ' + descriptor.jj() + ', but had ' + getKClassFromExpression(currentObject));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.p14();
        var keyDescriptor = carrierDescriptor(descriptor.dk(0), this_0.jm());
        var keyKind = keyDescriptor.bk();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
          var tmp_4 = this.p14();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          if (!(currentObject instanceof JsonObject)) {
            throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.jj() + ', but had ' + getKClassFromExpression(currentObject));
          }
          tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject);
        } else {
          if (this_0.q12_1.c14_1) {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
            var tmp_5 = this.p14();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            if (!(currentObject instanceof JsonArray)) {
              throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonArray) + ' as the serialized body of ' + descriptor.jj() + ', but had ' + getKClassFromExpression(currentObject));
            }
            tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_2;
      } else {
        var tmp_6 = this.p14();
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        if (!(currentObject instanceof JsonObject)) {
          throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.jj() + ', but had ' + getKClassFromExpression(currentObject));
        }
        tmp = new JsonTreeDecoder(tmp_6, currentObject);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).vl = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).fl = function () {
    var tmp = this.q1a();
    return !(tmp instanceof JsonNull);
  };
  protoOf(AbstractJsonTreeDecoder).s1a = function (tag) {
    var currentElement = this.r1a(tag);
    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_0(-1, 'Expected JsonPrimitive at ' + tag + ', found ' + currentElement, toString(this.q1a()));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).t1a = function (tag, enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.p14(), this.s1a(tag).w14());
  };
  protoOf(AbstractJsonTreeDecoder).m10 = function (tag, enumDescriptor) {
    return this.t1a((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).u1a = function (tag) {
    return !(this.r1a(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).c10 = function (tag) {
    return this.u1a((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).v1a = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'boolean');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'boolean');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).d10 = function (tag) {
    return this.v1a((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).w1a = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
        var result = get_int(this_0);
        var tmp;
        var containsLower = ByteCompanionObject_instance.MIN_VALUE;
        if (result <= ByteCompanionObject_instance.MAX_VALUE ? containsLower <= result : false) {
          tmp = toByte(result);
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'byte');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'byte');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).e10 = function (tag) {
    return this.w1a((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).x1a = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
        var result = get_int(this_0);
        var tmp;
        var containsLower = ShortCompanionObject_instance.MIN_VALUE;
        if (result <= ShortCompanionObject_instance.MAX_VALUE ? containsLower <= result : false) {
          tmp = toShort(result);
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'short');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'short');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).f10 = function (tag) {
    return this.x1a((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).y1a = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
        var tmp0_elvis_lhs = get_int(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'int');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'int');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).g10 = function (tag) {
    return this.y1a((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).z1a = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
        var tmp0_elvis_lhs = get_long(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'long');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'long');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).h10 = function (tag) {
    return this.z1a((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).a1b = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
        var tmp0_elvis_lhs = get_float(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'float');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'float');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.p14().q12_1.j14_1;
    if (specialFp ? true : isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.q1a()));
  };
  protoOf(AbstractJsonTreeDecoder).i10 = function (tag) {
    return this.a1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).b1b = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
        var tmp0_elvis_lhs = get_double(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'double');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'double');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.p14().q12_1.j14_1;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.q1a()));
  };
  protoOf(AbstractJsonTreeDecoder).j10 = function (tag) {
    return this.b1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).c1b = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var this_0 = this.s1a(tag);
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
        var tmp0_elvis_lhs = single(this_0.w14());
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
          unparsedPrimitive(this, 'char');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'char');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).k10 = function (tag) {
    return this.c1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).d1b = function (tag) {
    var value = this.s1a(tag);
    if (!this.p14().q12_1.b14_1) {
      var literal = asLiteral(value, this, 'string');
      if (!literal.y14_1)
        throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted.\n" + get_lenientHint(), toString(this.q1a()));
    }
    if (value instanceof JsonNull)
      throw JsonDecodingException_0(-1, "Unexpected 'null' value instead of string literal", toString(this.q1a()));
    return value.w14();
  };
  protoOf(AbstractJsonTreeDecoder).l10 = function (tag) {
    return this.d1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).e1b = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(new StringJsonLexer(this.s1a(tag).w14()), this.p14()) : protoOf(NamedValueDecoder).n10.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).n10 = function (tag, inlineDescriptor) {
    return this.e1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).rl = function (descriptor) {
    return !(this.zz() == null) ? protoOf(NamedValueDecoder).rl.call(this, descriptor) : (new JsonPrimitiveDecoder(this.p14(), this.f2())).rl(descriptor);
  };
  function coerceInputValue_0($this, descriptor, index, tag) {
    var tmp$ret$0;
    $l$block_3: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var this_0 = $this.p14();
      if (!descriptor.gk(index)) {
        tmp$ret$0 = false;
        break $l$block_3;
      }
      var elementDescriptor = descriptor.dk(index);
      var tmp;
      if (!elementDescriptor.uj()) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_0 = $this.r1a(tag);
        tmp = tmp_0 instanceof JsonNull;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_3;
      }
      if (equals(elementDescriptor.bk(), ENUM_getInstance())) {
        var tmp_1;
        if (elementDescriptor.uj()) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
          var tmp_2 = $this.r1a(tag);
          tmp_1 = tmp_2 instanceof JsonNull;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = false;
          break $l$block_3;
        }
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_3 = $this.r1a(tag);
        var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$0 = false;
          break $l$block_3;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_4;
        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
          tmp$ret$0 = true;
          break $l$block_3;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function absenceIsNull($this, descriptor, index) {
    $this.o1b_1 = (!$this.p14().q12_1.e14_1 ? !descriptor.gk(index) : false) ? descriptor.dk(index).uj() : false;
    return $this.o1b_1;
  }
  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
    polyDiscriminator = polyDiscriminator === VOID ? null : polyDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value);
    this.k1b_1 = value;
    this.l1b_1 = polyDiscriminator;
    this.m1b_1 = polyDescriptor;
    this.n1b_1 = 0;
    this.o1b_1 = false;
  }
  protoOf(JsonTreeDecoder).f2 = function () {
    return this.k1b_1;
  };
  protoOf(JsonTreeDecoder).lm = function (descriptor) {
    while (this.n1b_1 < descriptor.zj()) {
      var tmp1 = this.n1b_1;
      this.n1b_1 = tmp1 + 1 | 0;
      var name = this.uz(descriptor, tmp1);
      var index = this.n1b_1 - 1 | 0;
      this.o1b_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.f2();
      if ((isInterface(this_0, Map) ? this_0 : THROW_CCE()).j2(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.p1a_1.g14_1 ? true : !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  };
  protoOf(JsonTreeDecoder).fl = function () {
    return !this.o1b_1 ? protoOf(AbstractJsonTreeDecoder).fl.call(this) : false;
  };
  protoOf(JsonTreeDecoder).vz = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.p14());
    var baseName = descriptor.fk(index);
    if (strategy == null) {
      if (!this.p1a_1.k14_1)
        return baseName;
      if (this.f2().z1().z(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.p14(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.f2().z1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.w();
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
        if (deserializationNamesMap_0.m2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.i17(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  };
  protoOf(JsonTreeDecoder).r1a = function (tag) {
    return getValue(this.f2(), tag);
  };
  protoOf(JsonTreeDecoder).ul = function (descriptor) {
    if (descriptor === this.m1b_1) {
      var tmp = this.p14();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.q1a();
      var descriptor_0 = this.m1b_1;
      if (!(value instanceof JsonObject)) {
        throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor_0.jj() + ', but had ' + getKClassFromExpression(value));
      }
      return new JsonTreeDecoder(tmp, value, this.l1b_1, this.m1b_1);
    }
    return protoOf(AbstractJsonTreeDecoder).ul.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).vl = function (descriptor) {
    var tmp;
    if (this.p1a_1.a14_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.bk();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.p14());
    var tmp_1;
    if (strategy == null ? !this.p1a_1.k14_1 : false) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.p14(), descriptor).z1();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_safe_receiver = get_schemaCache(this.p14()).s19(descriptor, get_JsonDeserializationNamesKey());
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var tmp1_iterator = this.f2().z1().u();
    while (tmp1_iterator.v()) {
      var key = tmp1_iterator.w();
      if (!names.z(key) ? !(key === this.l1b_1) : false) {
        throw UnknownKeyException(key, this.f2().toString());
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.u1b_1 = value;
    this.v1b_1 = this.u1b_1.n();
    this.w1b_1 = -1;
  }
  protoOf(JsonTreeListDecoder).f2 = function () {
    return this.u1b_1;
  };
  protoOf(JsonTreeListDecoder).vz = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).r1a = function (tag) {
    return this.u1b_1.f1(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).lm = function (descriptor) {
    while (this.w1b_1 < (this.v1b_1 - 1 | 0)) {
      this.w1b_1 = this.w1b_1 + 1 | 0;
      return this.w1b_1;
    }
    return -1;
  };
  function JsonPrimitiveDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.c1c_1 = value;
    this.o10(get_PRIMITIVE_TAG());
  }
  protoOf(JsonPrimitiveDecoder).f2 = function () {
    return this.c1c_1;
  };
  protoOf(JsonPrimitiveDecoder).lm = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).r1a = function (tag) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(tag === get_PRIMITIVE_TAG())) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
      var message = "This input can only handle primitives with '" + get_PRIMITIVE_TAG() + "' tag";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.c1c_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.n1c_1 = value;
    this.o1c_1 = toList(this.n1c_1.z1());
    this.p1c_1 = imul(this.o1c_1.n(), 2);
    this.q1c_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).f2 = function () {
    return this.n1c_1;
  };
  protoOf(JsonTreeMapDecoder).vz = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.o1c_1.f1(i);
  };
  protoOf(JsonTreeMapDecoder).lm = function (descriptor) {
    while (this.q1c_1 < (this.p1c_1 - 1 | 0)) {
      this.q1c_1 = this.q1c_1 + 1 | 0;
      return this.q1c_1;
    }
    return -1;
  };
  protoOf(JsonTreeMapDecoder).r1a = function (tag) {
    return (this.q1c_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.n1c_1, tag);
  };
  protoOf(JsonTreeMapDecoder).vl = function (descriptor) {
  };
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.ii())).tl(deserializer);
  }
  function get_PRIMITIVE_TAG() {
    return PRIMITIVE_TAG;
  }
  var PRIMITIVE_TAG;
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, get_BEGIN_OBJ(), get_END_OBJ());
    WriteMode_LIST_instance = new WriteMode('LIST', 1, get_BEGIN_LIST(), get_END_LIST());
    WriteMode_MAP_instance = new WriteMode('MAP', 2, get_BEGIN_OBJ(), get_END_OBJ());
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, get_BEGIN_LIST(), get_END_LIST());
  }
  var $ENTRIES;
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.f1a_1 = begin;
    this.g1a_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.bk();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.dk(0), _this__u8e3s4.jm());
          var keyKind = keyDescriptor.bk();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.q12_1.c14_1) {
              // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.bk(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.ak()) {
      tmp = carrierDescriptor(_this__u8e3s4.dk(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.r1c(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.r1c(lastPosition, currentPosition);
    var result = $this.g13_1.toString();
    $this.g13_1.u7(0);
    return result;
  }
  function takePeeked($this) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.f13_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
    $this.f13_1 = null;
    return this_0;
  }
  function wasUnquotedString($this) {
    return !(charSequenceGet($this.s1c(), $this.d13_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.t1c(currentPosition);
    if (currentPosition === -1) {
      $this.e17('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.s1c();
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var currentChar = charSequenceGet(tmp, tmp0);
    if (currentChar === _Char___init__impl__6a9atx(117)) {
      return appendHex($this, $this.s1c(), currentPosition);
    }
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (c === _Char___init__impl__6a9atx(0)) {
      $this.e17("Invalid escaped char '" + toString_0(currentChar) + "'");
    }
    $this.g13_1.j5(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.d13_1 = startPos;
      $this.u1c();
      if (($this.d13_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.e17('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.d13_1);
    }
    $this.g13_1.j5(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      // Inline function 'kotlin.code' call
      var tmp_1 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      // Inline function 'kotlin.code' call
      var tmp_2 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
    } else {
      $this.e17("Invalid toHexChar char '" + toString_0(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean($this, start) {
    var current = $this.t1c(start);
    if (current >= charSequenceLength($this.s1c()) ? true : current === -1) {
      $this.e17('EOF');
    }
    // Inline function 'kotlin.code' call
    var tmp = $this.s1c();
    var tmp0 = current;
    current = tmp0 + 1 | 0;
    var this_0 = charSequenceGet(tmp, tmp0);
    var tmp1_subject = Char__toInt_impl_vasixd(this_0) | 32;
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(116);
    if (tmp1_subject === Char__toInt_impl_vasixd(this_1)) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(102);
      if (tmp1_subject === Char__toInt_impl_vasixd(this_2)) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.e17("Expected valid boolean literal prefix, but had '" + $this.i18() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.s1c()) - current | 0) < literalSuffix.length) {
      $this.e17('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charSequenceGet(literalSuffix, i);
        var actual = charSequenceGet($this.s1c(), current + i | 0);
        // Inline function 'kotlin.code' call
        var tmp = Char__toInt_impl_vasixd(expected);
        // Inline function 'kotlin.code' call
        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
          $this.e17("Expected valid boolean literal prefix, but had '" + $this.i18() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.d13_1 = current + literalSuffix.length | 0;
  }
  function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
    var tmp;
    switch (isExponentPositive) {
      case false:
        // Inline function 'kotlin.math.pow' call

        var x = -exponentAccumulator.w5();
        tmp = Math.pow(10.0, x);
        break;
      case true:
        // Inline function 'kotlin.math.pow' call

        var x_0 = exponentAccumulator.w5();
        tmp = Math.pow(10.0, x_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function AbstractJsonLexer() {
    this.d13_1 = 0;
    this.e13_1 = new JsonPath();
    this.f13_1 = null;
    this.g13_1 = StringBuilder_init_$Create$();
  }
  protoOf(AbstractJsonLexer).u1c = function () {
  };
  protoOf(AbstractJsonLexer).v1c = function (c) {
    return (((c === _Char___init__impl__6a9atx(125) ? true : c === _Char___init__impl__6a9atx(93)) ? true : c === _Char___init__impl__6a9atx(58)) ? true : c === _Char___init__impl__6a9atx(44)) ? false : true;
  };
  protoOf(AbstractJsonLexer).h13 = function () {
    var nextToken = this.k18();
    if (!(nextToken === 10)) {
      this.e17('Expected EOF after parsing, but had ' + toString_0(charSequenceGet(this.s1c(), this.d13_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).e18 = function (expected) {
    var token = this.k18();
    if (!(token === expected)) {
      this.w1c(expected);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).u19 = function (expected) {
    this.u1c();
    var source = this.s1c();
    var cpos = this.d13_1;
    $l$loop_0: while (true) {
      cpos = this.t1c(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var tmp0 = cpos;
      cpos = tmp0 + 1 | 0;
      var c = charSequenceGet(source, tmp0);
      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9))
        continue $l$loop_0;
      this.d13_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.x1c(expected);
    }
    this.d13_1 = cpos;
    this.x1c(expected);
  };
  protoOf(AbstractJsonLexer).x1c = function (expected) {
    if (this.d13_1 > 0 ? expected === _Char___init__impl__6a9atx(34) : false) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
        var snapshot = this.d13_1;
        try {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.unexpectedToken.<anonymous>' call
          this.d13_1 = this.d13_1 - 1 | 0;
          tmp$ret$1 = this.i18();
          break $l$block;
        }finally {
          this.d13_1 = snapshot;
        }
      }
      var inputLiteral = tmp$ret$1;
      if (inputLiteral === 'null') {
        this.d17("Expected string literal but 'null' literal was found", this.d13_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
      }
    }
    this.w1c(charToTokenClass(expected));
  };
  protoOf(AbstractJsonLexer).y1c = function (expectedToken, wasConsumed) {
    var expected = tokenDescription(expectedToken);
    var position = wasConsumed ? this.d13_1 - 1 | 0 : this.d13_1;
    var s = (this.d13_1 === charSequenceLength(this.s1c()) ? true : position < 0) ? 'EOF' : toString_0(charSequenceGet(this.s1c(), position));
    this.e17('Expected ' + expected + ", but had '" + s + "' instead", position);
  };
  protoOf(AbstractJsonLexer).w1c = function (expectedToken, wasConsumed, $super) {
    wasConsumed = wasConsumed === VOID ? true : wasConsumed;
    return $super === VOID ? this.y1c(expectedToken, wasConsumed) : $super.y1c.call(this, expectedToken, wasConsumed);
  };
  protoOf(AbstractJsonLexer).f18 = function () {
    var source = this.s1c();
    var cpos = this.d13_1;
    $l$loop_0: while (true) {
      cpos = this.t1c(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (((ch === _Char___init__impl__6a9atx(32) ? true : ch === _Char___init__impl__6a9atx(10)) ? true : ch === _Char___init__impl__6a9atx(13)) ? true : ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.d13_1 = cpos;
      return charToTokenClass(ch);
    }
    this.d13_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).w19 = function (doConsume) {
    var current = this.z1c();
    current = this.t1c(current);
    var len = charSequenceLength(this.s1c()) - current | 0;
    if (len < 4 ? true : current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet('null', i) === charSequenceGet(this.s1c(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 ? charToTokenClass(charSequenceGet(this.s1c(), current + 4 | 0)) === 0 : false)
      return false;
    if (doConsume) {
      this.d13_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).h1a = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.w19(doConsume) : $super.w19.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).z1c = function () {
    var current = this.d13_1;
    $l$loop_0: while (true) {
      current = this.t1c(current);
      if (current === -1)
        break $l$loop_0;
      var c = charSequenceGet(this.s1c(), current);
      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop_0;
      }
    }
    this.d13_1 = current;
    return current;
  };
  protoOf(AbstractJsonLexer).x19 = function (isLenient) {
    var token = this.f18();
    var tmp;
    if (isLenient) {
      if (!(token === 1) ? !(token === 0) : false)
        return null;
      tmp = this.i18();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.h18();
    }
    var string = tmp;
    this.f13_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).a1d = function () {
    this.f13_1 = null;
  };
  protoOf(AbstractJsonLexer).b1d = function (startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.s1c();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  };
  protoOf(AbstractJsonLexer).h18 = function () {
    if (!(this.f13_1 == null)) {
      return takePeeked(this);
    }
    return this.a1a();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.t1c(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.e17('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.r1c(lastPosition, currentPosition);
          currentPosition = this.t1c(currentPosition);
          if (currentPosition === -1) {
            this.e17('Unexpected EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.b1d(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.d13_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).b1a = function () {
    var result = this.i18();
    if (result === 'null' ? wasUnquotedString(this) : false) {
      this.e17("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).i18 = function () {
    if (!(this.f13_1 == null)) {
      return takePeeked(this);
    }
    var current = this.z1c();
    if (current >= charSequenceLength(this.s1c()) ? true : current === -1) {
      this.e17('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.s1c(), current));
    if (token === 1) {
      return this.h18();
    }
    if (!(token === 0)) {
      this.e17('Expected beginning of the string, but got ' + toString_0(charSequenceGet(this.s1c(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.s1c(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.s1c())) {
        usedAppend = true;
        this.r1c(this.d13_1, current);
        var eof = this.t1c(current);
        if (eof === -1) {
          this.d13_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.b1d(this.d13_1, current);
    } else {
      tmp = decodedString(this, this.d13_1, current);
    }
    var result = tmp;
    this.d13_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).r1c = function (fromIndex, toIndex) {
    this.g13_1.p7(this.s1c(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).z19 = function (allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList_init_$Create$();
    var lastToken = this.f18();
    if (!(lastToken === 8) ? !(lastToken === 6) : false) {
      this.i18();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.f18();
      if (lastToken === 1) {
        if (allowLenientStrings) {
          this.i18();
        } else {
          this.a1a();
        }
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
        tokenStack.r(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.d13_1, 'found ] instead of } at path: ' + this.e13_1, this.s1c());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.d13_1, 'found } instead of ] at path: ' + this.e13_1, this.s1c());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.e17('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.k18();
      if (tokenStack.n() === 0)
        return Unit_instance;
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + this.s1c() + "', currentPosition=" + this.d13_1 + ')';
  };
  protoOf(AbstractJsonLexer).y19 = function (key) {
    var processed = this.b1d(0, this.d13_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    this.d17("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  };
  protoOf(AbstractJsonLexer).d17 = function (message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.e13_1.r17() + hintMessage, this.s1c());
  };
  protoOf(AbstractJsonLexer).e17 = function (message, position, hint, $super) {
    position = position === VOID ? this.d13_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.d17(message, position, hint) : $super.d17.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).e15 = function () {
    var current = this.z1c();
    current = this.t1c(current);
    if (current >= charSequenceLength(this.s1c()) ? true : current === -1) {
      this.e17('EOF');
    }
    var tmp;
    if (charSequenceGet(this.s1c(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.s1c())) {
        this.e17('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var exponentAccumulator = new Long(0, 0);
    var isNegative = false;
    var isExponentPositive = false;
    var hasExponent = false;
    var start = current;
    $l$loop_4: while (!(current === charSequenceLength(this.s1c()))) {
      var ch = charSequenceGet(this.s1c(), current);
      if ((ch === _Char___init__impl__6a9atx(101) ? true : ch === _Char___init__impl__6a9atx(69)) ? !hasExponent : false) {
        if (current === start) {
          this.e17('Unexpected symbol ' + toString_0(ch) + ' in numeric literal');
        }
        isExponentPositive = true;
        hasExponent = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45) ? hasExponent : false) {
        if (current === start) {
          this.e17("Unexpected symbol '-' in numeric literal");
        }
        isExponentPositive = false;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(43) ? hasExponent : false) {
        if (current === start) {
          this.e17("Unexpected symbol '+' in numeric literal");
        }
        isExponentPositive = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.e17("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_4;
      current = current + 1 | 0;
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.e17("Unexpected symbol '" + toString_0(ch) + "' in numeric literal");
      }
      if (hasExponent) {
        // Inline function 'kotlin.Long.plus' call
        // Inline function 'kotlin.Long.times' call
        exponentAccumulator = exponentAccumulator.l8(toLong(10)).p9(toLong(digit));
        continue $l$loop_4;
      }
      // Inline function 'kotlin.Long.minus' call
      // Inline function 'kotlin.Long.times' call
      accumulator = accumulator.l8(toLong(10)).q9(toLong(digit));
      if (accumulator.m8(new Long(0, 0)) > 0) {
        this.e17('Numeric value overflow');
      }
    }
    var hasChars = !(current === start);
    if (start === current ? true : isNegative ? start === (current - 1 | 0) : false) {
      this.e17('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.e17('EOF');
      }
      if (!(charSequenceGet(this.s1c(), current) === _Char___init__impl__6a9atx(34))) {
        this.e17('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.d13_1 = current;
    if (hasExponent) {
      var doubleAccumulator = accumulator.w5() * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
      var tmp_0;
      Companion_getInstance_3();
      if (doubleAccumulator > (new Long(-1, 2147483647)).w5()) {
        tmp_0 = true;
      } else {
        Companion_getInstance_3();
        tmp_0 = doubleAccumulator < (new Long(0, -2147483648)).w5();
      }
      if (tmp_0) {
        this.e17('Numeric value overflow');
      }
      // Inline function 'kotlin.math.floor' call
      if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
        this.e17("Can't convert " + doubleAccumulator + ' to Long');
      }
      accumulator = numberToLong(doubleAccumulator);
    }
    var tmp_1;
    if (isNegative) {
      tmp_1 = accumulator;
    } else {
      var tmp_2 = accumulator;
      Companion_getInstance_3();
      if (!tmp_2.equals(new Long(0, -2147483648))) {
        tmp_1 = accumulator.u9();
      } else {
        this.e17('Numeric value overflow');
      }
    }
    return tmp_1;
  };
  protoOf(AbstractJsonLexer).i1a = function () {
    var current = this.z1c();
    if (current === charSequenceLength(this.s1c())) {
      this.e17('EOF');
    }
    var tmp;
    if (charSequenceGet(this.s1c(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean(this, current);
    if (hasQuotation) {
      if (this.d13_1 === charSequenceLength(this.s1c())) {
        this.e17('EOF');
      }
      if (!(charSequenceGet(this.s1c(), this.d13_1) === _Char___init__impl__6a9atx(34))) {
        this.e17('Expected closing quotation mark');
      }
      this.d13_1 = this.d13_1 + 1 | 0;
    }
    return result;
  };
  function charToTokenClass(c) {
    var tmp;
    // Inline function 'kotlin.code' call
    if (Char__toInt_impl_vasixd(c) < 126) {
      var tmp_0 = CharMappings_getInstance().d1d_1;
      // Inline function 'kotlin.code' call
      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function get_TC_WHITESPACE() {
    return TC_WHITESPACE;
  }
  var TC_WHITESPACE;
  function get_TC_EOF() {
    return TC_EOF;
  }
  var TC_EOF;
  function get_STRING() {
    return STRING;
  }
  var STRING;
  function get_TC_STRING() {
    return TC_STRING;
  }
  var TC_STRING;
  function get_STRING_ESC() {
    return STRING_ESC;
  }
  var STRING_ESC;
  function get_TC_BEGIN_OBJ() {
    return TC_BEGIN_OBJ;
  }
  var TC_BEGIN_OBJ;
  function get_TC_COLON() {
    return TC_COLON;
  }
  var TC_COLON;
  function get_TC_COMMA() {
    return TC_COMMA;
  }
  var TC_COMMA;
  function get_COLON() {
    return COLON;
  }
  var COLON;
  function get_BEGIN_OBJ() {
    return BEGIN_OBJ;
  }
  var BEGIN_OBJ;
  function get_END_OBJ() {
    return END_OBJ;
  }
  var END_OBJ;
  function get_BEGIN_LIST() {
    return BEGIN_LIST;
  }
  var BEGIN_LIST;
  function get_END_LIST() {
    return END_LIST;
  }
  var END_LIST;
  function get_lenientHint() {
    return lenientHint;
  }
  var lenientHint;
  function get_INVALID() {
    return INVALID;
  }
  var INVALID;
  function get_COMMA() {
    return COMMA;
  }
  var COMMA;
  function get_NULL() {
    return NULL;
  }
  var NULL;
  function tokenDescription(token) {
    return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
  }
  function get_TC_OTHER() {
    return TC_OTHER;
  }
  var TC_OTHER;
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().c1d_1[c] : _Char___init__impl__6a9atx(0);
  }
  function get_TC_BEGIN_LIST() {
    return TC_BEGIN_LIST;
  }
  var TC_BEGIN_LIST;
  function get_TC_END_LIST() {
    return TC_END_LIST;
  }
  var TC_END_LIST;
  function get_TC_END_OBJ() {
    return TC_END_OBJ;
  }
  var TC_END_OBJ;
  function get_ignoreUnknownKeysHint() {
    return ignoreUnknownKeysHint;
  }
  var ignoreUnknownKeysHint;
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!(esc === _Char___init__impl__6a9atx(117))) {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.c1d_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.d1d_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.c1d_1 = charArray(117);
    this.d1d_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function get_specialFlowingValuesHint() {
    return specialFlowingValuesHint;
  }
  var specialFlowingValuesHint;
  function get_allowStructuredMapKeysHint() {
    return allowStructuredMapKeysHint;
  }
  var allowStructuredMapKeysHint;
  function StringJsonLexer(source) {
    AbstractJsonLexer.call(this);
    this.i1d_1 = source;
  }
  protoOf(StringJsonLexer).s1c = function () {
    return this.i1d_1;
  };
  protoOf(StringJsonLexer).t1c = function (position) {
    return position < this.i1d_1.length ? position : -1;
  };
  protoOf(StringJsonLexer).k18 = function () {
    var source = this.i1d_1;
    $l$loop: while (!(this.d13_1 === -1) ? this.d13_1 < source.length : false) {
      var tmp1 = this.d13_1;
      this.d13_1 = tmp1 + 1 | 0;
      var ch = charSequenceGet(source, tmp1);
      var tc = charToTokenClass(ch);
      var tmp;
      if (tc === get_TC_WHITESPACE()) {
        continue $l$loop;
      } else {
        tmp = tc;
      }
      return tmp;
    }
    return get_TC_EOF();
  };
  protoOf(StringJsonLexer).v19 = function () {
    var current = this.z1c();
    if (current === this.i1d_1.length ? true : current === -1)
      return false;
    if (charSequenceGet(this.i1d_1, current) === _Char___init__impl__6a9atx(44)) {
      this.d13_1 = this.d13_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(StringJsonLexer).g18 = function () {
    var current = this.d13_1;
    if (current === -1)
      return false;
    $l$loop: while (current < this.i1d_1.length) {
      var c = charSequenceGet(this.i1d_1, current);
      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.d13_1 = current;
      return this.v1c(c);
    }
    this.d13_1 = current;
    return false;
  };
  protoOf(StringJsonLexer).z1c = function () {
    var current = this.d13_1;
    if (current === -1)
      return current;
    $l$loop: while (current < this.i1d_1.length) {
      var c = charSequenceGet(this.i1d_1, current);
      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.d13_1 = current;
    return current;
  };
  protoOf(StringJsonLexer).u19 = function (expected) {
    if (this.d13_1 === -1) {
      this.x1c(expected);
    }
    var source = this.i1d_1;
    $l$loop: while (this.d13_1 < source.length) {
      var tmp1 = this.d13_1;
      this.d13_1 = tmp1 + 1 | 0;
      var c = charSequenceGet(source, tmp1);
      if (((c === _Char___init__impl__6a9atx(32) ? true : c === _Char___init__impl__6a9atx(10)) ? true : c === _Char___init__impl__6a9atx(13)) ? true : c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      if (c === expected)
        return Unit_instance;
      this.x1c(expected);
    }
    this.d13_1 = -1;
    this.x1c(expected);
  };
  protoOf(StringJsonLexer).a1a = function () {
    this.u19(get_STRING());
    var current = this.d13_1;
    var closingQuote = indexOf(this.i1d_1, _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.i18();
      this.y1c(get_TC_STRING(), false);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(this.i1d_1, i) === get_STRING_ESC()) {
          return this.consumeString2(this.i1d_1, this.d13_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.d13_1 = closingQuote + 1 | 0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.i1d_1.substring(current, closingQuote);
  };
  protoOf(StringJsonLexer).c1a = function (keyToMatch, isLenient) {
    var positionSnapshot = this.d13_1;
    try {
      if (!(this.k18() === get_TC_BEGIN_OBJ()))
        return null;
      var firstKey = this.x19(isLenient);
      if (!(firstKey === keyToMatch))
        return null;
      this.a1d();
      if (!(this.k18() === get_TC_COLON()))
        return null;
      return this.x19(isLenient);
    }finally {
      this.d13_1 = positionSnapshot;
      this.a1d();
    }
  };
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.s12_1;
  }
  function JsonToStringWriter() {
    this.t12_1 = StringBuilder_init_$Create$_0(128);
  }
  protoOf(JsonToStringWriter).k16 = function (value) {
    this.t12_1.s7(value);
  };
  protoOf(JsonToStringWriter).e16 = function (char) {
    this.t12_1.j5(char);
  };
  protoOf(JsonToStringWriter).g16 = function (text) {
    this.t12_1.i5(text);
  };
  protoOf(JsonToStringWriter).q16 = function (text) {
    printQuoted(this.t12_1, text);
  };
  protoOf(JsonToStringWriter).u12 = function () {
    this.t12_1.v7();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.t12_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$(initialCapacity);
  }
  //region block: post-declaration
  protoOf(defer$1).uj = get_isNullable;
  protoOf(defer$1).ak = get_isInline;
  protoOf(defer$1).yj = get_annotations;
  protoOf(PolymorphismValidator).j12 = contextual;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion();
  Companion_instance_1 = new Companion_0();
  Companion_instance_2 = new Companion_1();
  Companion_instance_3 = new Companion_2();
  Tombstone_instance = new Tombstone();
  PRIMITIVE_TAG = 'primitive';
  TC_WHITESPACE = 3;
  TC_EOF = 10;
  STRING = _Char___init__impl__6a9atx(34);
  TC_STRING = 1;
  STRING_ESC = _Char___init__impl__6a9atx(92);
  TC_BEGIN_OBJ = 6;
  TC_COLON = 5;
  TC_COMMA = 4;
  COLON = _Char___init__impl__6a9atx(58);
  BEGIN_OBJ = _Char___init__impl__6a9atx(123);
  END_OBJ = _Char___init__impl__6a9atx(125);
  BEGIN_LIST = _Char___init__impl__6a9atx(91);
  END_LIST = _Char___init__impl__6a9atx(93);
  lenientHint = "Use 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.";
  INVALID = _Char___init__impl__6a9atx(0);
  COMMA = _Char___init__impl__6a9atx(44);
  NULL = 'null';
  TC_OTHER = 0;
  TC_BEGIN_LIST = 8;
  TC_END_LIST = 9;
  TC_END_OBJ = 7;
  ignoreUnknownKeysHint = "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.";
  specialFlowingValuesHint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
  allowStructuredMapKeysHint = "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.";
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Json_0;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-json.js.map
